import { addDoc, collection } from "firebase/firestore";
import { db } from "../utils/firebase-config";

export interface ErrorReport {
  uid: string;
  error: string;
  cause: string;
}

export function writeError({ uid, error, cause }: ErrorReport) {
  // Error reporting must never itself throw, so failures here are swallowed.
  return addDoc(collection(db, "errors"), {
    uid,
    error,
    cause,
    date: new Date()
  }).then(() => undefined);
}
